import { NgModule } from '@angular/core';
import {
  LucideAngularModule,
  Home,
  User,
  UserPlus,
  Bell,
  FolderCog,
  ChevronDown,
  Edit,
  FileText,
  HelpCircle,
  Info,
  LogOut,
  Menu,
  Plus,
  Search,
  Settings,
  Star,
  Hammer,
  Wrench,
  Pencil,
  Trash2,
  Fullscreen,
  CircleX,
  CircleGauge,
  Gauge,
  LayoutDashboard,
  Bug,
  Link2,
  Flag,
  Activity,
  HandCoins,
  CircleDollarSign,
  Landmark,
  ListPlus,
  FileClock,
  PanelsTopLeft,
  Library,
  BookText,
  Eye,
  Loader,
  Save,
  Replace,
  X,
  RectangleEllipsis,
  BookDashed,
  Inbox,
  ArrowLeftToLine,
  ArrowRightToLine,
  Filter,
  Contact,
  Store,
  CalendarDays,
  Calendar,
  AreaChart,
  TextCursorInput,
  ClipboardList,
  Timer,
  Check,
  OctagonX,
  ImageUp,
  Delete,
  Grip,
  EllipsisVertical,
  Copy,
  Clipboard,
  ClipboardPaste,
  PencilLine,
  SquareX,
  ArrowDown,
  ArrowUp,
  ChevronLeft,
  ChevronRight,
  Group,
  BetweenVerticalStart,
  ListX,
  Zap,
  Columns3,
  OctagonPause,
  AtSign,
  SearchX,
  Phone,
  Link,
  Unlink,
  BoxSelect,
  ArrowRight,
  ShieldAlert,
  BookA,
  ArrowUpFromLine,
  ArrowDownToLine,
  Upload,
  ThumbsUp,
  SquarePercent,
  Shapes,
  Maximize2,
  ClipboardType,
  CloudUpload,
  Download,
  CheckCheck,
  Printer,
  MonitorCheck,
  File,
  FileX,
  Clock,
  LayoutGrid,
  Lock,
  BarChart2,
  Users,
  Share2,
  UserRoundX,
  MessageCircle,
  Send,
  ChevronsRight,
  ChevronsLeft,
  PanelLeft,
  PanelRight,
  PanelLeftClose,
  SeparatorHorizontal,
  LayoutPanelLeft,
  ChevronUp,
  ChevronsUp,
  ChevronsDown,
  FileCheck,
  Unlock,
  FileEdit,
  MoreVertical,
  Scroll,
  Split,
  LayoutList,
  WandSparkles,
  GitBranch,
  ListOrdered,
  PlusCircle,
  Play,
  CheckCircle2,
  CheckCircle,
  FilePlus,
  XCircle,
  Key,
  ArrowLeft,
  KeyRound,
  CircleDot,
  Hash,
  EyeOff,
  ArrowUpDown,
  Sparkles,
  FileQuestion,
  FileDown,
  Ban,
  Shield,
  UserRoundCheck,
  Folder,
  Building2,
  Building,
  CheckSquare,
  GitMerge,
  BrainCircuit,
  Table,
  List,
  Calculator,
  Sidebar,
  Binoculars,
  CircleSmall,
  RefreshCw,
  Loader2,
  ShieldCheck,
  Lightbulb,
  TriangleAlert,
  Megaphone,
  CircleAlert,
  GripVertical,
  LightbulbOff,
  AlertCircle,
  Mail,
  RefreshCcw,
  Image,
  Layout,
  Monitor,
  Grid,
  Type,
  Minus,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  Database,
  FileImage,
  Table2,
  MousePointerClick,
  Square,
  Circle,
  Edit2,
  Edit3,
  Map,
  History,
  CircleCheck,
  CircleOff,
  FolderKey,
  FolderOpen,
  Paperclip,
} from 'lucide-angular';

@NgModule({
  imports: [
    LucideAngularModule.pick({
      Table,
      List,
      Link2,
      Layout,
      History,
      Edit2,
      Edit3,
      Monitor,
      RefreshCcw,
      CircleAlert,
      Megaphone,
      TriangleAlert,
      Lightbulb,
      Loader2,
      Calculator,
      LayoutGrid,
      Users,
      BrainCircuit,
      Folder,
      Play,
      Ban,
      GitMerge,
      Shield,
      Building2,
      Building,
      CheckSquare,
      UserRoundCheck,
      FileDown,
      Key,
      EyeOff,
      FileQuestion,
      Sparkles,
      ArrowUpDown,
      ArrowLeft,
      Hash,
      KeyRound,
      CheckCircle2,
      CheckCircle,
      ChevronUp,
      FilePlus,
      CircleDot,
      LayoutPanelLeft,
      FileCheck,
      Scroll,
      XCircle,
      Split,
      ListOrdered,
      PlusCircle,
      FileEdit,
      LayoutList,
      WandSparkles,
      GitBranch,
      Unlock,
      ChevronsUp,
      ChevronsDown,
      SeparatorHorizontal,
      PanelLeftClose,
      PanelLeft,
      PanelRight,
      Send,
      Share2,
      MessageCircle,
      UserRoundX,
      BarChart2,
      Lock,
      Clock,
      Home,
      User,
      UserPlus,
      Settings,
      Bell,
      FileText,
      LogOut,
      Menu,
      Hammer,
      ChevronDown,
      FolderCog,
      Wrench,
      Info,
      Star,
      Search,
      Plus,
      Edit,
      HelpCircle,
      Pencil,
      Trash2,
      Fullscreen,
      CircleX,
      CircleGauge,
      Gauge,
      LayoutDashboard,
      Bug,
      Flag,
      Activity,
      HandCoins,
      CircleDollarSign,
      Landmark,
      ListPlus,
      FileClock,
      PanelsTopLeft,
      Library,
      BookText,
      Eye,
      Loader,
      Save,
      Replace,
      RectangleEllipsis,
      X,
      BookDashed,
      Inbox,
      ArrowLeftToLine,
      ArrowRightToLine,
      Filter,
      Contact,
      Store,
      CalendarDays,
      Calendar,
      AreaChart,
      TextCursorInput,
      ClipboardList,
      Timer,
      Check,
      OctagonX,
      ImageUp,
      Grip,
      Delete,
      EllipsisVertical,
      Copy,
      Clipboard,
      ClipboardPaste,
      SquareX,
      PencilLine,
      ArrowUp,
      ArrowDown,
      ChevronLeft,
      ChevronRight,
      Group,
      ListX,
      BetweenVerticalStart,
      Zap,
      Columns3,
      OctagonPause,
      AtSign,
      Phone,
      Link,
      Unlink,
      SearchX,
      BoxSelect,
      ArrowRight,
      ShieldAlert,
      BookA,
      ThumbsUp,
      Upload,
      ArrowDownToLine,
      Shapes,
      SquarePercent,
      ArrowUpFromLine,
      Maximize2,
      ClipboardType,
      CloudUpload,
      Download,
      CheckCheck,
      Printer,
      MonitorCheck,
      File,
      FileX,
      ChevronsRight,
      ChevronsLeft,
      MoreVertical,
      Sidebar,
      Binoculars,
      CircleSmall,
      RefreshCw,
      ShieldCheck,
      GripVertical,
      LightbulbOff,
      AlertCircle,
      Mail,
      Image,
      Grid,
      Type,
      Minus,
      AlignLeft,
      AlignCenter,
      AlignRight,
      AlignJustify,
      Database,
      FileImage,
      Table2,
      MousePointerClick,
      Square,
      Circle,
      Map,
      CircleCheck,
      CircleOff,
      FolderKey,
      FolderOpen,
      Paperclip,
    }),
  ],
  exports: [LucideAngularModule],
  declarations: [],
  providers: [],
})
export class LucideIconsModule { }
